export default __webpack_public_path__ + "game_m443ae0.jpg";